import { mobileAndTabletCheck } from "../device/device";
import SystemPlatform from "../system/SystemPlatform";
import { injectable, inject } from "inversify";
import SERVICE_IDENTIFIER from "../constants/identifiers";
import SystemConfig from "../system/SystemConfig";
import IAudio from "../engine/IAudio";
import IHwButtons from "../ui/hwButtons/IHwButtons";
import AbstractStates from "./AbstractStates";
import { STATES } from "./states";
import IGame from "../game/IGame";
import PlayerOptions from "../player/PlayerOptions";

@injectable()
export default class BaseStates extends AbstractStates {
	private _uiStates: AbstractStates;
	private _config: SystemConfig;
	private _platform: SystemPlatform;
	private _game: IGame;
	private _audio: IAudio;
	private _hwButtons: IHwButtons;
	private _playerOptions: PlayerOptions;

	private _useHwButtons: boolean;

	constructor(
		@inject(SERVICE_IDENTIFIER.UIStates) uiStates: AbstractStates,
		@inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
		@inject(SERVICE_IDENTIFIER.Game) game: IGame,
		@inject(SERVICE_IDENTIFIER.EngineAudio) audio: IAudio,
		@inject(SERVICE_IDENTIFIER.HwButtonsStates) hwButtons: IHwButtons,
		@inject(SERVICE_IDENTIFIER.PlayerOptions) playerOptions: PlayerOptions
	) {
		super();

		this._uiStates = uiStates;
		this._config = config;
		this._platform = config.platform;
		this._game = game;
		this._audio = audio;
		this._hwButtons = hwButtons;
		this._playerOptions = playerOptions;
		this._useHwButtons = this._platform.isVLT();
	}

	beforeSetState() {}

	_setHWButtonsState(state) {
		this._useHwButtons && this._hwButtons.setState(state);
	}

	stateInit() {
		this._uiStates.setState(STATES.INIT);
	}

	stateReady() {
		this._uiStates.setState(STATES.READY);
	}

	stateLoaded() {
		this._uiStates.setState(STATES.LOADED);
	}

	async statePreinfo() {
		this._setHWButtonsState(STATES.PREINFO);
		this._uiStates.setState(STATES.PREINFO);

		return this.deferState(STATES.PREINFO);
	}

	stateSound() {
		// skip state SOUND on desktop and on mobiles and vlt if player option for sound is set
		if (
			this._playerOptions.isSoundSet() ||
			!mobileAndTabletCheck() ||
			this._platform.isVLT()
		) {
			this._audio.setChoosed(true);
			if (this._playerOptions.isSoundSet()) {
				this._playerOptions.getSound()
					? this._audio.unmute()
					: this._audio.mute();
			} else {
				this._audio.unmute(); // sound is enabled by default
			}
			return Promise.resolve(this._audio.isMuted());
		}

		// let user choose the sound on start
		this._uiStates.setState(STATES.SOUND);
		this._audio.setChoosed(true);

		return this.deferState(STATES.SOUND);
	}

	stateIdle() {
		this._setHWButtonsState(STATES.IDLE);
		this._uiStates.setState(STATES.IDLE);
	}

	stateFsIdle() {
		this._setHWButtonsState(STATES.FS_IDLE);
		this._uiStates.setState(STATES.FS_IDLE);
	}

	stateSpin() {
		this._setHWButtonsState(STATES.SPIN);
		this._uiStates.setState(STATES.SPIN);
	}

	stateSkip() {
		this._setHWButtonsState(STATES.SKIP);

		// if(this._game.autostart?.isAutostart()) {
		//     return;
		// }

		this._uiStates.setState(STATES.SKIP);
	}

	stateBonus() {
		this._setHWButtonsState(STATES.BONUS);

		if (this._game.autostart?.isAutostart()) {
			return;
		}

		this._uiStates.setState(STATES.BONUS);
	}

	stateForcespin() {
		this._setHWButtonsState(STATES.FORCESPIN);

		if (this._game.autostart?.isAutostart()) {
			return;
		}

		this._uiStates.setState(STATES.FORCESPIN);
	}

	stateBonusWin() {
		this._setHWButtonsState(STATES.BONUS_WIN);

		this._uiStates.setState(STATES.BONUS_WIN);
	}

	stateBonusWheel() {
		this._setHWButtonsState(STATES.BONUS_WHEEL);

		this._uiStates.setState(STATES.BONUS_WHEEL);
	}

	stateSearching() {
		this._setHWButtonsState(STATES.SEARCHING);

		this._uiStates.setState(STATES.SEARCHING);
	}

	stateError(error) {
		this._uiStates.setState(STATES.ERROR, error);
	}

	stateJokerBonusWin(data: any) {
		this._setHWButtonsState(STATES.JOKER_BONUS_WIN);

		this._uiStates.setState(STATES.JOKER_BONUS_WIN);
	}
}
